export default __webpack_public_path__ + "static/media/bhicon.a1987500.svg";